import Vue from 'vue';
import ResultInlineToasts from '../../../qaamgo/modules/sat/components/toasts/ResultInlineToasts.vue';

async function initResultInlineToasts() {
    if (global.gResultInlineToasts) {
        return global.gResultInlineToasts;
    }

    // make sure the toast is initialized only once
    global.gResultInlineToasts = (async () => {
        await import(
            /* webpackMode: "lazy-once" */
            `../../../entrypoints/translations/sat-translations.js`
        );

        new Vue({
            el: '#qg-result-inline-toast',
            name: 'ResultInlineToastyRoot',
            components: {
                ResultInlineToasts,
            },
            render(h) {
                return h(ResultInlineToasts);
            },
        });
    })();
}

export { initResultInlineToasts };
